import {Hydra} from '../generic/hydra';

import {PersonneInterface} from './Personne';
import {AffiliationInterface} from './Affiliation';
import {StatutChercheurInterface} from './StatutChercheur';
import {CountryInterface} from './Country';
import {PersonneResponsable as PersonneResponsableBaseInterface} from '../../interface/api/PersonneResponsable';

export type PersonneResponsableInterface = PersonneResponsableBaseInterface;

export class PersonneResponsable extends Hydra implements PersonneResponsableInterface {

    id?: number | null;

    personne?: PersonneInterface | string | null;

    email?: string | null;

    emailOther?: string | null;

    telephone?: string | null;

    dateNaissance?: Date | null;

    datePhd?: Date | null;

    affiliation?: AffiliationInterface | string | null;

    affiliationOther?: string | null;

    statutChercheur?: StatutChercheurInterface | string | null;

    statutChercheurOther?: string | null;

    cvCourt?: string | null;

    nationalites?: CountryInterface[] | string[] | null = [];

    numORCID?: string | null;


    constructor(options: PersonneResponsableInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
